/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-17
 * Permission constants 
 * Must match with the keys that server returns inside permissions object
 * for each user.
 * These ones are used to validate build the app menu dynamically or
 * validate action buttons.
 */

/**
 * Read page spefic permissions
 * CRUD on this pages
 */
export const CUSTOMS_CLEARENCE_PERMISSION = 'customsClearence';
export const CUSTOMERS_PERMISSION = 'customers';
export const USERS_PERMISSION = 'users';
export const CUSTOMS_HOUSES_PERMISSION = 'customsHouses';
export const SUPPLIERS_PERMISSION = 'suppliers';
export const INVOICE_ITEM_PERMISSION = 'invoiceItem';
export const REPORTS_PERMISSION = 'reports';
export const CUSTOMS_CLEARENCE_STATUSES_PERMISSION = 'customsClearenceStatuses';

/**
 * Permission to allow CRUD operations for specific actions
 */
export const TABULAR_PRICES_PERMISSION = 'tabularPrices';//Create a tabular for an user
export const ATTACHMENTS_PERMISSION = 'attachments';//Related with attachments
export const PRE_INVOICE_PERMISSION = 'preInvoice'; //Access to create pre invoices
export const REQUESTING_PAYMENT_PERMISSION = 'requestingPayment'; //Allowed to modify only this field

const getPermission = (permission, permissions, operation) => {
    if (!permission) { return false; }
    if (!(permission in permissions)) { return false; }
    return permissions[permission][operation] || false;
};

/**
 * Validate if user has create permission
 * @param {string} permission permission to apply
 * @param {obj} permissions all user permissions
 */
export const hasCreatePermission = (permission, permissions) => {
    return getPermission(permission, permissions, 'create');
};

/**
 * Validate if user has create permission
 * @param {string} permission permission to apply
 * @param {obj} permissions all user permissions
 */
export const hasReadPermission = (permission, permissions) => {
    return getPermission(permission, permissions, 'read');
};

/**
 * Validate if user has create permission
 * @param {string} permission permission to apply
 * @param {obj} permissions all user permissions
 */
export const hasUpdatePermission = (permission, permissions) => {
    return getPermission(permission, permissions, 'update');
};

/**
 * Validate if user has create permission
 * @param {string} permission permission to apply
 * @param {obj} permissions all user permissions
 */
export const hasDeletePermission = (permission, permissions) => {
    return getPermission(permission, permissions, 'delete');
};

export const getPagePermissions = (pageKey, permissions) => {
    const defaults = { create: false, read: false, update: false, delete: false };
    return permissions[pageKey] || defaults;
};



// WEBPACK FOOTER //
// ./security/permissions.js